export const Drawer = {
  baseStyle: {
    body: {
      px: "10",
      pb: "10",
    },
    header: {
      px: "10",
      pt: "10",
    },
    footer: {
      py: "6",
      px: "10",
    },
  },
};
